import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from '../css/NewBooking.module.css';
import BottomTab from './BottomTab';
import { FaSpinner } from 'react-icons/fa6';
import HeaderBar from '../components/HeaderBar';
import { FaSearch } from 'react-icons/fa';

const NewBooking = () => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(false);const [error, setError] = useState('');

	const navigate = useNavigate();

	const fetchBookings = async () => {
		try {
			const response = await axios.get(
				'https://hometech-repairs.in/homeTech/fetch_created_bookings.php'
			);

			if (response.data.status) {
				setBookings(response.data.data);
			}
		} catch (error) {
			console.error('Error fetching bookings:', error);
			setError('An error occurred while fetching bookings.');
		} finally {
			setLoading(false);
			setRefreshing(false);
		}
	};

	useEffect(() => {
		fetchBookings();
		const interval = setInterval(fetchBookings, 5000);

		return () => clearInterval(interval);
	}, []);

	const onRefresh = useCallback(() => {
		setRefreshing(true);
		fetchBookings();
	}, []);

	return (
		<div className={styles.container}>
			<HeaderBar title={'New Booking'} />

			{loading ? (
				<div className={styles.loader}>Loading...</div>
			) : (
				<div>
					<button className={styles.refreshButton} onClick={onRefresh}>
						<FaSpinner size={20} color="white" />
					</button>
				
					<Link className={styles.refreshButton} to={"/search"}>
						<FaSearch size={20} color="white" />
					</Link>

					<div className={styles.bookingsList}>
						<p>{error}</p>
						{bookings.length > 0 ? (
							bookings.map((item) => (
								<div
									key={item.order_number}
									className={styles.card}
									onClick={() =>
										navigate(`/Booking-Details/${item.order_number}`)
									}
								>
									<p className={styles.label}>
										<strong>Order No:</strong> {item.order_number}
									</p>
									<p className={styles.label}>
										<strong>Service:</strong> {item.service}
									</p>
									<p className={styles.label}>
										<strong>Location:</strong> {item.location}
									</p>
								</div>
							))
						) : (
							<p>No bookings available.</p>
						)}
					</div>
				</div>
			)}
			<BottomTab />
		</div>
	);
};

export default NewBooking;
